var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "48px",
    viewBox: "0 0 20 20",
    width: "48px",
    fill: "grey",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20,
    x: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,3L4,5v4.31c0,3.55,2.56,6.88,6,7.69c3.44-0.81,6-4.13,6-7.69V5L10,3z M15,9.31c0,1.37-0.45,2.68-1.18,3.8l-1.38-1.38 C12.79,11.24,13,10.65,13,10c0-1.66-1.34-3-3-3s-3,1.34-3,3s1.34,3,3,3c0.65,0,1.24-0.21,1.73-0.56l1.47,1.47 c-0.86,0.97-1.95,1.71-3.2,2.06c-2.87-0.79-5-3.61-5-6.65V5.72l5-1.67l5,1.67V9.31z M10,12c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2 s2,0.9,2,2C12,11.1,11.1,12,10,12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.01475af192a79020fe7ead5f658cb9a1.svg";
export { ForwardRef as ReactComponent };